import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CommonFunctions } from 'src/app/shared/common/common-functions';
import { FormFunctions } from 'src/app/shared/form-components/form-functions';
import { BaseFormComponent } from 'src/app/shared/form-components/base-form.component';
import { StaticLocations } from 'src/assets/staticdata/static-locations';

@Component({
  selector: 'app-mailing-address',
  templateUrl: './mailing-address.component.html',
  styleUrls: ['./mailing-address.component.scss'],
  standalone: false,
})
export class MailingAddressComponent extends BaseFormComponent{
  @Input() formGroup?: UntypedFormGroup;
  @Input() propertyId?: string;  
  @Input() addressTypesData?: [];  
  @Input() prefix?: string ='';  
  @Input() inputProvinces?: any;
  @Input() inputCountries?: any;
  @Output() userInputProvinceChanged? = new EventEmitter<string>();
  @Output() userInputCountryChanged? = new EventEmitter<string>();
  @Output() userInputAddressTypeChanged? = new EventEmitter<string>();
  

  provinces;  
  countries;
  regular  = true;
  constructor(   
    commonFunctions: CommonFunctions,
    public formFunctions: FormFunctions,) {
    super(commonFunctions);   
   } 

   ngOnInit() {    
    if (this.inputProvinces != null) {
      this.provinces = this.inputProvinces
    } else {
      this.provinces = StaticLocations.Provinces;
    }   
    
    if (this.inputCountries != null) {
      this.countries = this.inputCountries
    } else {
      this.countries = StaticLocations.Countries;
    }
  }

  onProvinceChanged(input) {
    this.userInputProvinceChanged.emit(input.target?.value);
  }
  
  onCountryChanged(input) {
    this.userInputCountryChanged.emit(input.target?.value);
  }
  onAddressTypeChanged(input) {   
    this.userInputAddressTypeChanged.emit(input.target?.value);
  }  
}